import { useMutation, useQueryClient } from '@tanstack/react-query';
import { favoriteMarketService } from 'shared/src/api';
import { queryKey } from '../constant/queryKey';
import { bridge } from 'shared/src/utils';
import type { GoodsDetailResponse } from 'shared/src/api/goodsService/getGoodsDetail/types';
import { useGoodsSno } from '../hooks/useGoodsSno';

export const usePostFavoriteMarket = (marketId?: number) => {
  const goodsSno = useGoodsSno();
  const client = useQueryClient();

  return useMutation({
    mutationFn: () => {
      if (!marketId) throw new Error('marketId is required');

      return favoriteMarketService
        .post({ sno: marketId })
        .then(res => res.data);
    },
    onSuccess: () => {
      bridge.favoriteMarket({ market_sno: marketId!, is_favorite: true });
      client.setQueryData<GoodsDetailResponse>(
        queryKey.goodsDetail(goodsSno),
        oldData => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            goods: {
              ...oldData.goods,
              market: {
                ...oldData.goods.market,
                is_favorite: true,
              },
            },
          };
        },
      );
    },
  });
};
